import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/intake`;

// Returns { ok, data } or { ok:false, message, fieldErrors }
export async function postIntake(path, body) {
  try {
    const { data } = await axios.post(`${BASE}${path}`, body, { timeout: 15000 });
    return { ok: true, data };
  } catch (err) {
    const res = err.response;
    if (res?.status === 422) {
      const fieldErrors = {};
      let message = "Please check the highlighted fields.";
      (res.data?.errors || []).forEach((e) => {
        const key = e.field.split(".")[0];
        if (key === "body") message = e.message;
        else fieldErrors[key] = fieldErrors[key] || e.message;
      });
      return { ok: false, message, fieldErrors };
    }
    if ([403, 404, 409].includes(res?.status)) return { ok: false, status: res.status, message: res.data?.detail, fieldErrors: {} };
    if ([429, 503].includes(res?.status)) return { ok: false, status: res.status, message: res.data?.detail, fieldErrors: {} };
    if (res?.status === 429) return { ok: false, message: res.data?.detail, fieldErrors: {} };
    return { ok: false, message: "We couldn’t save your details. Nothing was lost — please try again.", fieldErrors: {} };
  }
}

export async function getIntakeEnabled() {
  try {
    const { data } = await axios.get(`${BASE}/config`, { timeout: 10000 });
    return data.enabled === true;
  } catch {
    return false;
  }
}

export const newKey = () =>
  window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export const PHONE_RE = /^\+[1-9][0-9 ()-]{6,22}$/;
